/**
 * UI Library i18n exports
 *
 * Consuming apps merge `uiResources` into their i18n configuration.
 */

import { de } from './locales/de'
import { en } from './locales/en'
import { fr } from './locales/fr'
import { it } from './locales/it'

type UiNamespace = Record<string, unknown>

type UiLocaleResources = {
  ui: UiNamespace
  gwr: UiNamespace
  characteristics: UiNamespace
}

const bucket = (catalogue: {
  ui: unknown
  gwr: unknown
  characteristics: unknown
}): UiLocaleResources => ({
  ui: catalogue.ui as UiNamespace,
  gwr: catalogue.gwr as UiNamespace,
  characteristics: catalogue.characteristics as UiNamespace,
})

export const uiResources: Record<'en' | 'fr' | 'de' | 'it', UiLocaleResources> =
  {
    en: bucket(en),
    fr: bucket(fr),
    de: bucket(de),
    it: bucket(it),
  }

export { useTranslation } from 'react-i18next'
